import { render, staticRenderFns } from "./SourcesSection.vue?vue&type=template&id=5b16ed96&scoped=true&"
import script from "./SourcesSection.vue?vue&type=script&lang=js&"
export * from "./SourcesSection.vue?vue&type=script&lang=js&"
import style0 from "./SourcesSection.vue?vue&type=style&index=0&id=5b16ed96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16ed96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
